export const showMessage = (status: number | string): string => {
  let message = ''
  switch (status) {
    case 400:
      message = '请求失败！请您稍后重试'
      break
    case 401:
      message = '未授权，请重新登录'
      break
    case 403:
      message = '当前账号无访问权限'
      break
    case 404:
      message = '访问资源不存在'
      break
    case 405:
      message = '请求方法不被允许'
      break
    case 408:
      message = '请求超时'
      break
    case 500:
      message = '服务器内部错误'
      break
    case 501:
      message = '服务未实现'
      break
    case 502:
      message = '网关错误'
      break
    case 503:
      message = '服务不可用'
      break
    case 504:
      message = '网关超时'
      break
    case 505:
      message = 'HTTP版本不受支持'
      break
    default:
      message = `请求失败`
  }
  return message
}
